//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import RbHeaderBaseSidePanel from '@/elements/header/panels/base-side-panel.vue'
import { HEADER_MINIMUM_Z_INDEX } from '@/scripts/constants/header'

export default {
  name: 'rb-header-navigation-submenu-panel',
  components: {
    RbHeaderBaseSidePanel,
  },
  props: {
    isOpen: Boolean,
    zIndex: {
      type: Number,
      default: HEADER_MINIMUM_Z_INDEX,
    },
    offsets: Object,
    headerIsCollapsed: Boolean,
    variant: String,
  },
  methods: {
    emitBack() {
      this.$emit('back')
    },
    emitClose() {
      this.$emit('close')
    },
  },
}
